export default __webpack_public_path__ + "static/media/FlagIcon.861da414.svg";